<template>
  <v-card class="pa-6" :style="{ borderRadius: '16px 16px 16px 16px' }">
    <v-row no-gutters>
      <v-col cols="12">
        <v-row class="d-flex align-center mb-4">
          <v-col>
            <h2>ข่าวประชาสัมพันธ์</h2>
          </v-col>
          <v-col class="d-flex justify-end">
            <v-btn
              :color="['KKU_ADMIN', 'SPU_ADMIN'].includes(theme) ? 'bg_primary_register' : 'primary'"
              outlined
              rounded
              @click="addNews"
            >
              เพิ่มข่าว
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="mb-2">
        <v-row no-gutters justify-end>
          <v-col cols="12" sm class="mr-2" style="align-content: center">
            <span class="text-table-title"
              >ทั้งหมดจำนวน {{ newsData.data_totalCount }} รายการ</span
            >
          </v-col>
          <v-col cols="12" sm="5" class="pr-sm-2 py-2 py-sm-0">
            <v-text-field
              v-model="search"
              placeholder="ค้นหารายการ"
              outlined
              hide-details="auto"
              dense
              rounded
            >
              <template v-slot:append>
                <v-icon color="primary">mdi-magnify</v-icon>
              </template></v-text-field
            >
          </v-col>
          <v-col cols="12" sm="3">
            <v-select
              v-model="selectedFilter"
              :items="filters"
              item-text="name"
              item-value="status"
              placeholder="ข่าวทั้งหมด"
              hide-details="auto"
              outlined
              dense
              rounded
            >
              <template v-slot:append>
                <v-icon color="primary">mdi-chevron-down</v-icon>
              </template></v-select
            >
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" v-if="refCode === 'moph'">
        <div class="news-filters">
          <span
            v-for="filter in newsFilters"
            :key="filter.id"
            class="filter-chip"
            @click="toggleFilter(filter.id)"
            :style="{
              display: 'inline-block',
              padding: '8px 16px',
              borderRadius: '16px',
              margin: '4px',
              cursor: 'pointer',
              backgroundColor: filter.bgColor,
              border: new_type_id.includes(filter.id)
                ? `2px solid ${filter.textColor}`
                : '2px solid transparent',
              color: new_type_id.includes(filter.id)
                ? filter.textColor
                : filter.textColor,
            }"
          >
            <span
              class="dot"
              :style="{
                backgroundColor: filter.textColor,
                width: '8px',
                height: '8px',
                display: 'inline-block',
                borderRadius: '50%',
                marginRight: '8px',
              }"
            ></span>
            {{ filter.name }}
          </span>
        </div>
      </v-col>

      <v-col cols="12">
        <v-data-table
          :headers="dynamicHeaders"
          :items="newsData.data"
          :search="search"
          :page.sync="page"
          :items-per-page.sync="itemsPerPage"
          :server-items-length="newsData.data_totalCount"
          item-value="id"
          class="elevation-1 custom-table-text"
          :footer-props="{
            itemsPerPageText: 'จำนวนแถว:',
            itemsPerPageOptions: [5, 10, 20, 50],
          }"
        >
          <template slot="item.title" slot-scope="{ item }">
            <v-chip v-if="item.status === 'Draft'" color="#D2DDF9" small>
              <span style="color: #2b60e1">Draft</span>
            </v-chip>
            <span>
              {{ item.title }}
            </span>
          </template>
          <template
            slot="item.new_types_th"
            slot-scope="{ item }"
            v-if="refCode === 'moph'"
          >
            <span
              v-if="item.new_types_th"
              class="tag"
              :style="{
                backgroundColor:
                  getTypeConfig(item.new_types_th)?.bgColor || '#f5f5f5',
                color: getTypeConfig(item.new_types_th)?.textColor || '#9e9e9e',
              }"
            >
              <span
                :style="{
                  backgroundColor:
                    getTypeConfig(item.new_types_th)?.textColor || '#9e9e9e',
                  width: '8px',
                  height: '8px',
                  display: 'inline-block',
                  borderRadius: '50%',
                  marginRight: '8px',
                }"
              ></span>
              {{ item.new_types_th || "ไม่มีประเภทข่าว" }}
            </span>

            <span
              v-else
              class="tag"
              :style="{
                backgroundColor: '#FAFAFA',
                color: '#757575',
              }"
            >
              <span
                :style="{
                  backgroundColor: '#C8C8C8',
                  width: '8px',
                  height: '8px',
                  display: 'inline-block',
                  borderRadius: '50%',
                  marginRight: '8px',
                }"
              ></span>
              ไม่มีประเภทข่าว
            </span>
          </template>

          <template v-slot:[`item.created_at`]="{ item }">
            <div v-if="item.created_at != '-'">
              {{
                new Date(item.created_at).toLocaleDateString("th-TH", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                }) || "-"
              }}
            </div>
            <div v-else>{{ item.created_at }}</div>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex">
              <v-btn
                @click="editNews(item.business_id, item.news_id)"
                outlined
                rounded
              :color="theme === 'KKU_ADMIN' ? 'bg_text_register' : 'default_button_primary'"
                class="mr-2"
              >
                <v-icon left :color="theme === 'KKU_ADMIN' ? 'bg_text_register' : 'default_button_primary'"
                  >mdi-pencil-outline</v-icon
                >
                <span  :color="theme === 'KKU_ADMIN' ? 'bg_text_register' : 'default_button_primary'">แก้ไข</span>
              </v-btn>

              <v-btn
                @click="openConfirmDialog(item)"
                outlined
                rounded
                color="error"
              >
                <v-icon left>mdi-delete</v-icon>
                <span>ลบ</span>
              </v-btn>
            </div>
          </template>

          <template slot="no-data">
            <div class="table-nodata py-13">
              <v-row no-gutters justify="center">
                <v-col cols="12" style="text-align: -webkit-center">
                  <v-img
                    src="@/assets/no_news_data.png"
                    :aspect-ratio="$vuetify.breakpoint.xsOnly ? '1' : '4'"
                    contain
                    :width="$vuetify.breakpoint.mdAndUp ? '140px' : '95px'"
                    :height="$vuetify.breakpoint.mdAndUp ? '120px' : '80px'"
                  ></v-img>
                </v-col>
                <v-col cols="12">
                  <p style="font-weight: 700">ไม่พบรายการที่ค้นหา</p>
                </v-col>
                <v-col cols="12">
                  <p>กรุณาทำการค้นหาใหม่อีกครั้ง</p>
                </v-col>
              </v-row>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-overlay
      v-if="businessProfileCompleted == 0"
      :value="true"
      class="work-page-overlay d-flex flex-column align-center justify-center"
    >
      <v-card
        elevation="2"
        class="pa-4 d-flex flex-column align-center justify-center"
      >
        <v-card-text class="text-center">
          <p>กรุณากรอกข้อมูลโปรไฟล์ธุรกิจ</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <v-dialog
      v-model="deleteDialog"
      transition="dialog-bottom-transition"
      width="450"
      style="z-index: 2500"
    >
      <v-card class="text-center dialog-select pa-6">
        <v-img
          class="mb-4"
          src="@/assets/confirm_save.png"
          height="140px"
          contain
        ></v-img>
        <div>
          <span class="sub-title-text"
            >คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูลข่าวประชาสัมพันธ์</span
          >
        </div>
        <p>"{{ newsItemToDelete ? newsItemToDelete.title : "" }}"</p>
        <div class="pt-8 mx-sm-10 text-center dialog-select">
          <v-btn
            color="default_button_primary"
            :width="$vuetify.breakpoint.smAndUp ? '120' : ''"
            outlined
            @click="deleteDialog = false"
          >
            <b>ยกเลิก</b>
          </v-btn>
          <v-btn
            class="ml-3 savebutton"
            :width="$vuetify.breakpoint.smAndUp ? '120' : ''"
            color="default_button_primary"
            dark
            @click="
              deleteNews(newsItemToDelete.business_id, newsItemToDelete.news_id)
            "
          >
            ยืนยัน
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {},
  data() {
    return {
      search: "",
      filters: [
        {
          name: "ข่าวทั้งหมด",
          status: null,
        },
        {
          name: "แบบร่าง",
          status: "Draft",
        },
        {
          name: "โพสต์แล้ว",
          status: "Active",
        },
      ],
      newsFilters: [
        {
          id: 1,
          name: "สมัครใหม่",
          color: "green",
          bgColor: "rgba(76, 175, 80, 0.1)",
          textColor: "#4caf50",
        },
        {
          id: 2,
          name: "ย้ายภายในกรม",
          color: "pink",
          bgColor: "rgba(233, 30, 99, 0.1)",
          textColor: "#e91e63",
        },
        {
          id: 3,
          name: "โอนภายในกระทรวง",
          color: "light-blue",
          bgColor: "rgba(3, 169, 244, 0.1)",
          textColor: "#03a9f4",
        },
        {
          id: 4,
          name: "โอนต่างกระทรวง",
          color: "grey",
          bgColor: "rgba(158, 158, 158, 0.1)",
          textColor: "#9e9e9e",
        },
      ],
      refCode: localStorage.getItem("refcode") || null,
      theme: process.env.VUE_APP_USE_THEME,
      page: 1,
      pagination: 1,
      status: null,
      itemsPerPage: 10,
      itemsPerPageOptions: [5, 10, 20, 50],
      selectedFilter: null,
      new_type_id: [],
      sort: "DESC",
      headers: [
        { text: "วันที่", value: "created_at", width: "15%", align: "center" },
        { text: "รายการ", value: "title", width: "55%" },
        {
          text: "ประเภท",
          value: "new_types_th",
          width: "25%",
          align: "center",
        },
        {
          text: "จัดการ",
          value: "actions",
          width: "15%",
          sortable: false,
          align: "center",
          headerAlign: "center",
        },
      ],
      businessProfileCompleted:
        localStorage.getItem("business_profile_complete") || "-",
      deleteDialog: false,
      newsItemToDelete: null,
    };
  },
  computed: {
    ...mapGetters({
      newsData: "newsData",
    }),
    formattedNewsData() {
      return this.newsData.map((item) => {
        const formattedDate = new Date(item.created_at).toLocaleDateString(
          "th-TH",
          {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }
        );
        return {
          ...item,
          created_at: formattedDate,
          title: `{${item.status}} ${item.title}`,
        };
      });
    },
    filteredNews() {
      return this.newsData.data.filter(
        (item) =>
          this.new_type_id.length === 0 ||
          this.new_type_id.includes(item.new_type_id)
      );
    },

    dynamicHeaders() {
      const baseHeaders = [
        { text: "วันที่", value: "created_at", width: "15%", align: "center" },
        { text: "รายการ", value: "title", width: "55%" },
        {
          text: "จัดการ",
          value: "actions",
          width: "15%",
          sortable: false,
          align: "center",
          headerAlign: "center",
        },
      ];

      if (this.refCode === "moph") {
        baseHeaders.splice(2, 0, {
          text: "ประเภท",
          value: "new_types_th",
          width: "25%",
          align: "center",
        });
      }

      return baseHeaders;
    },
  },
  async created() {
    await this.$store.dispatch("getBusinessProfile");
    await this.$store.dispatch("getBusinessNews");
    await this.checkLocalStorage();
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.checkLocalStorage);
  },
  watch: {
    page(val, oldVal) {
      if (val != oldVal) {
        this.getListNewsData();
      }
    },
    itemsPerPage(val, oldVal) {
      if (val != oldVal) {
        this.getListNewsData();
      }
    },
    search(val, oldVal) {
      if (val != oldVal) {
        this.page = 1;
        this.itemsPerPage = 10;
        this.sort_by = "DESC";
        this.new_type_id = [];
        this.getListNewsData();
      }
    },
    work_total_list_for_approve(val, oldVal) {
      if (val != oldVal) {
        this.pagination = Math.ceil(
          this.listDataTotal[this.tabMenu] / this.itemsPerPage
        );
      }
    },
    selectedFilter(val, oldVal) {
      if (val != oldVal) {
        this.page = 1;
        this.itemsPerPage = 10;
        this.sort_by = "DESC";
        this.new_type_id = [];
        this.getListNewsData();
      }
    },
    businessProfileCompleted(val, oldVal) {
      if (val !== oldVal) {
        this.checkLocalStorage();
      }
    },
  },
  methods: {
    editNews(business_id, news_id) {
      this.$router.push({
        path: `/business_profile/edit_news/${business_id}/${news_id}`,
      });
    },

    getTypeConfig(typeName) {
      return this.newsFilters.find((type) => type.name === typeName);
    },
    async deleteNews(business_id, news_id) {
      try {
        const headers = {
          "Content-Type": "application/json",
        };

        const response = await this.axios.delete(
          `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/business_news/${business_id}/${news_id}`,
          { headers }
        );

        if (response.data.code == 200) {
          this.$store.commit("onAlerting", {
            message_status: "ลบข้อมูลสำเร็จ",
            color: "#58A144",
          });
          this.deleteDialog = false;
        }
        this.getListNewsData();
      } catch (error) {
        console.error("Error fetching news details:", error);
      }
    },
    addNews() {
      this.$router.push("/business_profile/create_news");
    },
    async getListNewsData() {
      this.$store.commit("onLoading");

      await this.$store
        .dispatch("getBusinessNews", {
          status: this.selectedFilter,
          sort: this.sort_by,
          search: this.search,
          page: this.page,
          limit_per_page: this.itemsPerPage,
          new_type_id: this.new_type_id.join(","),
        })
        .catch((err) =>
          this.$store.commit("onAlerting", {
            message_status: err.message,
            color: "#D1392B",
          })
        )
        .finally(() => setTimeout(() => this.$store.commit("offLoading"), 600));
    },
    checkLocalStorage() {
      this.businessProfileCompleted =
        localStorage.getItem("business_profile_completed") || "-";
    },
    openConfirmDialog(item) {
      this.newsItemToDelete = item;
      this.deleteDialog = true;
    },
    async toggleFilter(filterId) {
      const index = this.new_type_id.indexOf(filterId);
      if (index === -1) {
        this.new_type_id.push(filterId);
      } else {
        this.new_type_id.splice(index, 1);
      }

      await this.getListNewsData();
    },
  },
};
</script>

<style scoped>
.custom-table-text {
  color: #667085;
}
.text-table-title {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}
.filter-bar {
  display: flex;
  width: 100%;
  gap: 8px;
  justify-content: end;
}
.work-page-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(1px);
  z-index: 10;
}
.dialog-select {
  font-family: Noto Sans Thai !important;
}

.news-filters {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  padding: 24px;
}

.filter-chip {
  display: flex;
  align-items: center;
  border-radius: 24px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  border-width: 2px;
  height: 35px;
}

.filter-chip.active {
  font-weight: bold;
}

.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;
  transition: background-color 0.3s ease-in-out;
}

.dot.blue {
  background-color: #2196f3;
}

.dot.green {
  background-color: #4caf50;
}

.dot.pink {
  background-color: #e91e63;
}

.dot.light-blue {
  background-color: #03a9f4;
}

.dot.grey {
  background-color: #9e9e9e;
}

.tag {
  padding: 4px 8px;
  border-radius: 16px;
  display: inline-block;
  margin: 4px;
}

@media (max-width: 768px) {
  .tag {
    padding: 2px 4px;
    border-radius: 16px;
    margin: 4px;
  }
}
</style>
